import { createSlice } from "@reduxjs/toolkit";

import {
  resetRouteManagement,
  fetchDepotRoutes,
  editRoute,
  updateRouteEdit,
  updateRouteEditRoadSpeed,
  cancelRouteEdit,
  setIsRouteEditValid,
  removeRoute,
  addRoute,
  saveRoute,
} from "./thunkActions";

const initialState = {
  loading: false,
  isRemovingRoute: false,
  isRouteEditValid: true,
  maxAdditionalMinutes: "00:00",
  routes: [],
  routeConfig: [],
  routeEdit: null,
  routeEditCopy: null,
};

export const routeManagementSlice = createSlice({
  name: "routeManagement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetRouteManagement.fulfilled, () => initialState)
      .addCase(fetchDepotRoutes.pending, (state) => {
        state.loading = true;
        state.routes = [];
        state.routeConfig = {};
      })
      .addCase(fetchDepotRoutes.fulfilled, (state, action) => {
        const { maxAdditionalMinutes, routeConfig, routes } = action.payload;
        state.loading = false;
        state.maxAdditionalMinutes = maxAdditionalMinutes;
        state.routes = routes;
        state.routeConfig = routeConfig;
      })
      .addCase(editRoute.pending, (state) => {
        state.loading = true;
        state.routeEdit = null;
        state.routeEditCopy = null;
      })
      .addCase(editRoute.rejected, (state) => {
        state.loading = false;
        state.routeEdit = null;
        state.routeEditCopy = null;
      })
      .addCase(editRoute.fulfilled, (state, action) => {
        state.loading = false;
        state.routeEdit = action.payload;
        state.routeEditCopy = action.payload;
      })
      .addCase(updateRouteEdit.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRouteEdit.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateRouteEdit.fulfilled, (state, action) => {
        state.loading = false;
        state.routeEdit = action.payload;
      })
      .addCase(updateRouteEditRoadSpeed.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRouteEditRoadSpeed.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateRouteEditRoadSpeed.fulfilled, (state, action) => {
        state.loading = false;
        state.routeEdit = action.payload;
      })
      .addCase(addRoute.pending, (state) => {
        state.loading = true;
      })
      .addCase(addRoute.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addRoute.fulfilled, (state, action) => {
        state.loading = false;
        state.routeEdit = null;
        state.routeEditCopy = null;
        state.routes = action.payload;
      })
      .addCase(saveRoute.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveRoute.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveRoute.fulfilled, (state, action) => {
        state.loading = false;
        state.routeEdit = null;
        state.routeEditCopy = null;
        state.routes = action.payload;
      })
      .addCase(removeRoute.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeRoute.rejected, (state) => {
        state.loading = false;
      })
      .addCase(removeRoute.fulfilled, (state, action) => {
        state.loading = false;
        state.routeEdit = null;
        state.routeEditCopy = null;
        state.routes = action.payload;
      })
      .addCase(cancelRouteEdit, (state) => {
        state.routeEdit = null;
        state.routeEditCopy = null;
      })
      .addCase(setIsRouteEditValid, (state, action) => {
        state.isRouteEditValid = action.payload;
      });
  },
});

const { reducer } = routeManagementSlice;
export { initialState, reducer };
